import { isApiMocked } from '@/lib/env'
import { apiClient } from '@/lib/api-client'
import type { GetUserInfoResponse } from '../types'

const MOCK_USER: GetUserInfoResponse = {
  cohort: 'local-dev',
  school: 'dev-school',
  preferences: {},
}

export async function fetchUserInfo(userId: string): Promise<GetUserInfoResponse> {
  if (isApiMocked) return MOCK_USER
  return apiClient.get<GetUserInfoResponse>(`/user/${userId}`)
}
